<template>
  <div class="vgt-global-search vgt-clearfix" style="width: 100%">
    <div class="vgt-global-search__input vgt-pull-right">
      <span class="input__icon ts-cursor-pointer" @click.prevent="onEnter">
        <div class="magnifying-glass"></div>
      </span>

      <input
        v-model="model.search_value"
        type="text"
        ref="search_barcode"
        @keypress.enter="onEnter"
        placeholder="Search product(Press F2 move focus)"
        class="vgt-input vgt-pull-right"
      />

      <span class="input__icon ts-cursor-pointer" @click.prevent="onEnter">
        <div class="magnifying-glass"></div>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        search_value: '',
        substitute_code: ''
      })
    }
  },

  data() {
    return {
      model: {
        search_value: '',
        substitute_code: ''
      }
    }
  },

  mounted() {
    this.$refs.search_barcode.focus()
  },

  created() {
    window.addEventListener('keydown', this.handleKeydown)
    this.model = this.value
    if (typeof this.model.search_value === 'undefined') {
      this.$set(this.model, 'search_value', '')
    }
    if (typeof this.model.substitute_code === 'undefined') {
      this.$set(this.model, 'substitute_code', '')
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    handleKeydown(e) {
      if (e.keyCode === 113 && this.$refs.search_barcode) {
        this.$refs.search_barcode.focus()
      }
    },
    onEnter() {
      this.$emit('onEnter')
    }
  }
}
</script>
